module.exports = __webpack_public_path__ + "static/media/Vector 384.6bb11a47.svg";